import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { initSentry } from "@/sentry";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";
import App from "@/App";

// Initialize Sentry before anything renders so we catch boot-time errors.
// No-op in dev / preview — only runs when REACT_APP_SENTRY_ENABLED=true
// and REACT_APP_SENTRY_DSN is configured (set in production build env).
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
